import { Body, Button } from '../../UI/Elements';
import React from 'react';
import { Label } from 'components/UI/Elements/Label/label';
import { Image } from 'components/UI/Media';
import clsx from 'clsx';

const QuizStart = ({ startQuiz, header, title, image, body, start, gaTag }) => {
  return (
    <div
      className={
        'py-10 space-y-6 flex w-full flex-col justify-center align-center items-center'
      }>
      <div className={clsx('px-8 py-1', 'bg-redChristmas')}>
        <Label
          text={header?.text}
          size={'xs'}
          color={{ classname: 'white' }}
        />
      </div>
      <div className={'max-w-lg'}>
        <Label
          text={title?.text}
          size={'4xl'}
          align={'text-center'}
        />
      </div>

      <Button
        onClick={startQuiz}
        label={{ text: start.label?.text }}
        type='contained'
        color={{ classname: 'christmas-red' }}
      />
      <Image
        {...image}
        objectPlacement={'center'}
      />

      {body ? (
        <div className={'max-w-xl mt-4mx-12 text-center'}>
          <Body {...body} />
        </div>
      ) : null}
    </div>
  );
};

export default QuizStart;
